
import { mapState, mapGetters, mapActions } from 'vuex'
import { analytics } from '~/plugins/firebase.js'
import { logEvent } from 'firebase/analytics'

export default {
  head() {
    return {
      title: 'Schools',
    }
  },
  computed: {
    ...mapState({
      authUser: (state) => state.authUser,
    }),
    ...mapGetters([
      'isLoggedIn',
      'emailVerified',
      'isAdmin',
      'isGraduate',
      'isIndustry',
      'allSchools',
      'graduateSchools',
      'regions',
      'schoolById',
    ]),
    schoolsToSearch() {
      // If admin and show all schools selected return allSchools from stat
      if (this.showAllSchools) {
        return this.allSchools
      } else {
        // If not all schools (i.e. graduate and industry users) create a new array of schools with graduates
        return this.allSchools.flatMap((school) =>
          school.graduates !== true ? [] : [school]
        )
      }
    },
    showSchools() {
      // create a copy of the allschools array
      let schools = [...this.allSchools]
      if (!this.showAllSchools) {
        // create a new copy of the array with schools with graduates
        schools = schools.flatMap((school) =>
          school.graduates !== true ? [] : [school]
        )
      }
      if (this.selectedSchool) {
        // filter out only 1 school
        return schools.filter((school) => school.id === this.selectedSchool)
      } else {
        // sort schools by orderby
        return schools.sort((a, b) =>
          a[this.orderBy] < b[this.orderBy] ? -1 : 1
        )
      }
    },
  },
  data: () => ({
    showAllSchools: false,
    selectedSchool: null,
    loading: true,
    orderBy: 'name',
  }),
  async beforeMount() {
    await this.getSchools()
  },
  async mounted() {
    this.loading = false
  },
  methods: {
    ...mapActions(['getSchools']),
    logSearchTerm(term) {
      logEvent(analytics, 'search', { search_term: term })
    },
  },
}
